import { render } from "./ProjectData.vue?vue&type=template&id=36030f8e&scoped=true"
import script from "./ProjectData.vue?vue&type=script&lang=js"
export * from "./ProjectData.vue?vue&type=script&lang=js"

import "./ProjectData.vue?vue&type=style&index=0&id=36030f8e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36030f8e"]])

export default __exports__